import * as ActionTypes from '../ActionTypes';

const initialState = {
    company_config_data : "",
    configLoading: false
};

const CompanyConfigReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.COMPANY_CONFIG_GET_REQUEST:
            return {
                ...state,
                configLoading: true,
                company_config_data: []
            };
        case ActionTypes.COMPANY_CONFIG_UPDATE_REQUEST:
            return {
                ...state,
                configLoading: true,
            };
        case ActionTypes.COMPANY_CONFIG_GET_SUCCESS:
        case ActionTypes.COMPANY_CONFIG_UPDATE_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                configLoading: false,
                company_config_data: action.payload?.data?.data?.[0]|| {}
            };
        case ActionTypes.COMPANY_CONFIG_GET_ERROR:
        case ActionTypes.COMPANY_CONFIG_UPDATE_ERROR:
            return {
                ...state,
                configLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default CompanyConfigReducer;